import type { AlertItem } from "@/types/alert";

export type PushAlertPayload = Omit<AlertItem, "id">;

const actionTypes = {
  PUSH_ALERT: "PUSH_ALERT",
  REMOVE_ALERT: "REMOVE_ALERT",
  CLEAR_ALERTS: "CLEAR_ALERTS",
} as const;

type AlertAction =
  | { type: typeof actionTypes.PUSH_ALERT; payload: PushAlertPayload }
  | { type: typeof actionTypes.REMOVE_ALERT; payload: number }
  | { type: typeof actionTypes.CLEAR_ALERTS };

const initialState: AlertItem[] = [];

/* Actions */
const actions = {
  pushAlert: (payload: PushAlertPayload) => ({ type: actionTypes.PUSH_ALERT, payload }),
  removeAlert: (id: number) => ({ type: actionTypes.REMOVE_ALERT, payload: id }),
  clearAlerts: () => ({ type: actionTypes.CLEAR_ALERTS }),
};

/* Reducer */
const reducer = (state: AlertItem[] = initialState, action: AlertAction): AlertItem[] => {
  switch (action.type) {
    case actionTypes.PUSH_ALERT: {
      // 為每個 alert 生成唯一 ID，確保不可變性
      const newAlert: AlertItem = {
        ...action.payload,
        id: Date.now(),
      };
      return [...state, newAlert];
    }
    case actionTypes.REMOVE_ALERT:
      return state.filter(({ id }) => id !== action.payload);
    case actionTypes.CLEAR_ALERTS:
      return [];
    default:
      return state;
  }
};

export { reducer, actions };
